import { CSSProperties, FunctionComponent, ReactNode } from 'react';
import styles from './cardContainer.module.css';

type CardContainerProps = {
  style?: CSSProperties;
  shadow?: boolean;
  className?: string;
  children: ReactNode;
  background?: string;
};

const CardContainer: FunctionComponent<CardContainerProps> = (
  props: CardContainerProps,
) => {
  return (
    <div
      className={` ${props.background ? props.background : 'bg-[#ffffff]'} ${
        styles.container
      } ${props.shadow && styles.shadow}  ${props.className} `}
      style={props.style}
    >
      {props.children}
    </div>
  );
};

export default CardContainer;
